import React from 'react';

import { MissingNftsAction } from './components';

import { ChildrenWrapper, FiltersListWrapper } from './styles';

type FiltersListProps = {
    filterList: React.ReactNode;
};
export function FiltersList({ filterList }: FiltersListProps) {
    return (
        <FiltersListWrapper>
            <ChildrenWrapper>{filterList}</ChildrenWrapper>
            <MissingNftsAction />
        </FiltersListWrapper>
    );
}
